import './styles.css';
import { usePathLookupIpAutocompleteUnicast } from 'components/Graph/GraphSidePanel/GraphPathlookup/usePathLookupIpAutocompleteUnicast';

import { Button } from 'components/Button/Button';
import { FormikSelectField } from 'components/FormikSelectField/FormikSelectField';
import { FormikTypeaheadInput } from 'components/FormikTypeaheadInput/FormikTypeaheadInput';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import type { HostToDefaultGWFormValues } from 'components/Graph/GraphSidePanel/GraphPathlookup/HostToDefaultGWFormValues';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import type { SyntheticEvent } from 'react';
import { PathLookupDropdownMenu } from './PathLookupDropdownMenu';
import type { Vrf } from './fetchVrf';
import { getVrfOption } from './helpers/getVrfOption';

interface Props {
  formik: FormikProps<HostToDefaultGWFormValues>;
  vrf: Vrf[];
}

export const GraphHostToDefaultGWForm: FC<Props> = (props) => {
  const msg = useLocale();

  const ctxProps = useGraphContextSelectors({
    graphLoading: (s) => s.loading === 'LOADING',
  });

  const startingPointAutocomplete = usePathLookupIpAutocompleteUnicast();

  const vrfOptions = props.vrf.map((item) => getVrfOption(item, msg));

  const handleStartButtonClick = (e: SyntheticEvent) => {
    e.preventDefault();

    props.formik.submitForm();
  };

  return (
    <form className='py-4'>
      <div className='relative mx-5 flex'>
        <div className='flex-1'>
          <FormikTypeaheadInput
            label={
              msg.canvasGraph.graphSidePanel.pathlookup.hostToDefaultGW
                .startingPoint
            }
            autoTrim='all'
            formik={props.formik}
            inputClassName='ipf-input-group__input'
            loading={startingPointAutocomplete.loading}
            menuContent={
              <PathLookupDropdownMenu
                data={startingPointAutocomplete.content}
                name='startingPoint'
                formik={props.formik}
              />
            }
            name='startingPoint'
            onFocus={startingPointAutocomplete.search}
            onSearch={startingPointAutocomplete.search}
          />
        </div>
        <div className='ml-2.5 w-32'>
          <FormikSelectField
            label={
              msg.canvasGraph.graphSidePanel.pathlookup.hostToDefaultGW.vrf
            }
            formik={props.formik}
            name='vrf'
            options={vrfOptions}
            nonClearable
          />
        </div>
      </div>
      <div className='mt-lgu-6 flex justify-center'>
        <Button
          variant='primary'
          onClick={handleStartButtonClick}
          size='sm'
          loading={ctxProps.graphLoading}
          type='submit'
        >
          {msg.canvasGraph.graphSidePanel.pathlookup.hostToDefaultGW.btnSubmit}
        </Button>
      </div>
    </form>
  );
};
